export default function Loading() {
  return (
    <div className="d-flex justify-content-center align-items-center flex-column">
      <h1 className="mt-4">LOADING...</h1>
      <br />
      <img src="/images/pac-man.gif" alt="loading..." height={100} className="mb-4"/>
    </div>
  );
}
